import React from 'react';
import { useStoreState } from "easy-peasy";

class AudioEyeSupport extends React.Component {

    constructor() {
        super();
        this.Setting = useStoreState((state) => state.siteSettingsModel);
    }

    setup = () => {
        if(this.Setting.mainSettings.AudioEye !== null){
            
            let hash = this.Setting.mainSettings.AudioEye
            console.log("Loading Audio Eye Support: " + hash)
            var b = function() {
                window.__AudioEyeSiteHash = hash;
                var a = document.createElement("script");
                a.src = "https://wsmcdn.audioeye.com/aem.js";
                a.type = "text/javascript";
                a.setAttribute("async", "");
                document.getElementsByTagName("body")[0].appendChild(a)
                console.log("Audio Eye Support inserted!")
            };
            "complete" !== document.readyState ? window.addEventListener ? window.addEventListener("load", b) : window.attachEvent && window.attachEvent("onload", b) : b();
        }
        return this
    }

    LoadNeuroId = () => {
        (function(n,e,u,r,o,i,d){
            n.nid=n.nid||function(){(n.nid.q=n.nid.q||[]).push(arguments)};
            o=e.createElement(u);i=e.getElementsByTagName(u)[0];o.async=1;
            o.src=r;i.parentNode.insertBefore(o,i);
            })(window,document,'script','//scripts.neuro-id.com/c/nid-knelt487'+((process.env.REACT_APP_CFC_APPLICANT_BUILDENV !== "PRODUCTION") ? '-test' : '')+'.js')
           return this
    }

    setNid = (ProductName) => {
        window.nid('identify', sessionStorage.getItem("oldSessionToken"));
        window.nid('setVariable', 'funnel', ProductName)

        return this
       
    }
}

export default AudioEyeSupport